class ReviewCarousel extends HTMLElement {
    constructor() {
      super();
        this.reviewContent = this.querySelector('[data-review-slider]');
        this.reviewImages = this.querySelector('[data-review-image-slider]');
        this.mobileSLider = this.querySelector('[data-mobile-review-slider]');
        this.autoplay = this.dataset.autoplay;
        this.sliderSpeed = this.dataset.speed * 1000;
        this.initSliders();

    }
  
    initSliders(){
      var _this = this;
      let autoplayObj = false;
        var imageSwiper = new Swiper(this.reviewImages, {
            effect: "slide",
            //autoHeight: true,
            spaceBetween: 30,
            loop: true, // Not recommended to enable!!!
            allowTouchMove: false
          });
          
          
          var $Speed = 1000;

          if (this.autoplay == 'true') {
            autoplayObj = {
              delay: this.sliderSpeed,
              disableOnInteraction: true,
            }
          }
          
          var reviewSwiper = new Swiper(this.reviewContent, {
            autoplay: autoplayObj,
            speed: $Speed,
            loop: true, // Not recommended to enable!!!
            longSwipesRatio: 0.01,
            spaceBetween: 30,
            followFinger: false,
            grabCursor: true, 
            watchSlidesProgress: true,
            keyboard: true,
            lazy: {
                  loadPrevNext: true,
              },
            navigation: {
              nextEl: '.review-swiper-button-next',
              prevEl: '.review-swiper-button-prev',
            },
            pagination: {
                el: ".review-swiper-pagination",
                type: "progressbar",
              },
          });
          
          reviewSwiper.controller.control = imageSwiper;

          reviewSwiper.on('slideChange', function (slider) {
            let index = slider.activeIndex;
            let iconImg = _this.reviewImages.querySelectorAll('.rev-image-slides')[index].dataset.iconBadgeUrl;
            let iconWd = _this.reviewImages.querySelectorAll('.rev-image-slides')[index].dataset.iconBadgeWidth;
            let iconHt = _this.reviewImages.querySelectorAll('.rev-image-slides')[index].dataset.iconBadgeHeight;
            if(document.querySelector('[data-icon-badge]') != null && iconImg != null){
              document.querySelector('[data-icon-badge]').setAttribute('src',iconImg);
              document.querySelector('[data-icon-badge]').style.cssText = `
              width: ${iconWd}px;
              height: ${iconHt}px;
            `;
            }
          });

          var mobreviewSwiper = new Swiper(this.mobileSLider, {
            autoplay: autoplayObj,
            speed: $Speed,
            loop: true, // Not recommended to enable!!!
            longSwipesRatio: 0.01,
            followFinger: false,
            grabCursor: true, 
            watchSlidesProgress: true,
            lazy: {
                  loadPrevNext: true,
              },
            navigation: {
              nextEl: '.mobile-review-swiper-button-next',
              prevEl: '.mobile-review-swiper-button-prev',
            },
            pagination: {
                el: ".mobile-review-swiper-pagination",
                type: "progressbar",
              },
          });

          mobreviewSwiper.on('slideChange', function (slider) {
            let index = slider.activeIndex;
            let iconImg = _this.mobileSLider.querySelectorAll('.review-image')[index].dataset.mobIconBadgeUrl;
            let iconWd = _this.mobileSLider.querySelectorAll('.review-image')[index].dataset.mobIconBadgeWidth;
            let iconHt = _this.mobileSLider.querySelectorAll('.review-image')[index].dataset.mobIconBadgeHeight;
            if(document.querySelector('[data-mob-icon-badge]') != null && iconImg != null){
              document.querySelector('[data-mob-icon-badge]').setAttribute('src',iconImg);
              document.querySelector('[data-mob-icon-badge]').style.cssText = `
              width: ${iconWd}px;
              height: ${iconHt}px;
            `;
            }
          });

          
    }
  }
  
  customElements.define('review-carousel', ReviewCarousel);
  